import { PropsWithChildren } from 'react';
import {
  shouldShowTabByCommercialModules,
  useEnabledFeatures,
} from '@agilelab/plugin-wb-platform';
import { WitboostCommercialModule } from '@agilelab/plugin-wb-platform-common';

type CommercialGateProps = PropsWithChildren<{
  required?: WitboostCommercialModule[];
  fallback?: JSX.Element | null;
}>;

export function CommercialGate(props: CommercialGateProps): JSX.Element | null {
  const { required, fallback, children } = props;
  const { isCommercialModuleLicensed } = useEnabledFeatures();

  const visible = shouldShowTabByCommercialModules(
    required,
    isCommercialModuleLicensed,
  );

  if (!visible) return fallback ?? null;
  return <>{children}</>;
}
